import React, { useState, useEffect } from "react";
import ActionCellRender from "../../components/actionCellRender";
import { IconTrash, IconPencil, IconSettings, IconLink } from "@tabler/icons";
import {
  PageList,
  ENUM_FORM_DISPLAY,
  ENUM_FORM_LAYOUT_CONTAINER,
} from "../../components/pageList";
import { useCellRender } from "../../hooks/useCellRender";
import { useServerApi } from "../../hooks/userServerApi";
import { Group, UnstyledButton, Text } from "@mantine/core";
import { PeriodFilter } from "../../components/periodFilter";
import _ from "lodash";
import ReactJson from "react-json-view";
import { useAuthUser } from "react-auth-kit";
import FormSection from "../../components/formSection";
import { Page } from "../../layout/page";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import DataTable from "../../components/dataTable";
import useDeepCompareEffect from "../../hooks/useDeepCompareEffect";
import { resolveEntityPath } from "../../utils/resolveEntityPath";
import { openEntityEditTab } from "../../utils/openEntityEditTab";
import { useTabNavigate } from "../../hooks/useTabNavigate";
import { McaApprovalListBadge } from "../../components/mca/McaEntityIndicators";
const apiEntity = "order";

const initialValues = {
  type: "NEW",
  name: "",
  payment: {},
  termination: {},
  signedPlace: "Hong Kong",
  consultants: [],
  signedDate: "", //moment().format("YYYY-MM-DD"),
};

export default function OrderRenewal({ role = "CONSULTANT", numQuarters = 4 }) {
  const [cellRender] = useCellRender();
  const [api] = useServerApi();
  const auth = useAuthUser();
  const [preQuery, setPreQuery] = useState(null);
  const [period, setPeriod] = useState({
    startDate: moment().subtract(1, "month").endOf("month").format(),
    endDate: moment().endOf("month").format(),
  });
  const navigate = useNavigate();
  const location = useLocation();
  const tabNav = useTabNavigate();
  const consultantId = auth().id;

  const [orders, setOrders] = useState([]);

  const getOrderLinkPath = () =>
    resolveEntityPath("order", auth()?.userRole, location.pathname);

  const openOrder = (e, order) => {
    e.preventDefault();
    e.stopPropagation();
    if (!order?._id) return;
    openEntityEditTab(tabNav, {
      entity: "order",
      id: order._id,
      label: order.code,
      userRole: auth()?.userRole,
      currentPathname: location.pathname,
    });
  };

  const formatRenewalDate = (policyCommenceDate) => {
    if (!policyCommenceDate) return "-";
    const selectedYear = moment(period.endDate).year();
    const monthDay = moment(policyCommenceDate).format("MM-DD");
    return `${selectedYear}-${monthDay}`;
  };

  const createQuery = () => {
    const q = [{ "payment.payMode": "ANNUALLY" }, { status: "INF" }];

    if (period.startDate)
      q.push({
        $expr: {
          $gt: [
            { $month: "$policyCommenceDate" },
            moment(period.startDate).month() + 1,
          ],
        },
      });

    if (period.endDate)
      q.push({
        $expr: {
          $lte: [
            { $month: "$policyCommenceDate" },
            moment(period.endDate).month() + 1,
          ],
        },
      });

    q.push({
      $expr: {
        $lt: [{ $year: "$policyCommenceDate" }, moment(period.endDate).year()],
      },
    });
    if (role === "CONSULTANT") {
      q.push({ consultants: auth().id });
    }

    console.log("query:", q);
    return { $and: q };
  };

  // const fetchRenewal = async () => {
  //   try {
  //     // if (_.isEmpty(period)) return;
  //     const result = await api.Order.getRenewal(period, consultantId);
  //     if (result.data) {
  //       return setOrders(result.data.orders);
  //     } else setOrders([]);
  //     console.log("result", result);
  //   } catch (error) {
  //     console.log(error);
  //     // toast.error(result.message);
  //   }
  // };

  const tableSchema = {
    showActionColumn: true,
    preQuery,
    showOnlyPreQueryReady: true,
    columns: [
      {
        field: "code",
        headerName: "Order",
        sortable: true,
        cellRender: (col, order) => {
          return (
            <Group noWrap miw={110}>
              <span>
                <Group spacing={4} noWrap>
                  {cellRender.Order.type(order.type)}
                  {cellRender.Order.status(order.status)}
                  <McaApprovalListBadge entity={order} />
                </Group>
                {order._id && getOrderLinkPath() ? (
                  <Text
                    component="span"
                    size="xs"
                    sx={{ cursor: "pointer", textDecoration: "none" }}
                    onClick={(e) => openOrder(e, order)}
                  >
                    {order.code}
                  </Text>
                ) : (
                  <Text size="xs">{order.code}</Text>
                )}
              </span>
            </Group>
          );
        },
      },
      {
        field: "policyCommenceDate",
        headerName: "Renewal Date",
        sortable: true,
        cellRender: (col, order) => formatRenewalDate(order.policyCommenceDate),
      },
      {
        field: "policyNumber",
        headerName: "Policy No.",
        cellRender: (col, data) => (
          <span>
            <Text size="xs" sx={{ whiteSpace: "nowrap" }}>
              {data.policyNumber || "-"}
            </Text>
            <Text color="dimmed" size="xs" sx={{ whiteSpace: "nowrap" }}>
              {data.policyCommenceDate
                ? moment(data.policyCommenceDate).format("YYYY-MM-DD")
                : ""}
            </Text>
          </span>
        ),
      },
      {
        field: "client",
        sortable: true,
        cellRender: (col, data) => cellRender.ClientInfo(data.client, true),
      },
      {
        field: "consultants",
        headerName: "Consultants",
        sortable: true,
        cellRender: (col, data) =>
          cellRender.Users(data.consultants, 3, true, false),
      },
      {
        field: "payment.premium",
        headerName: "Preimum",
        sortable: true,
        cellRender: (col, order) => (
          <>
            {order.payment.premium
              ? `${order.payment.currency}  ${Intl.NumberFormat().format(
                  order.payment.premium
                )}`
              : "-"}
            <br />
            {order.payment.payMode}
          </>
        ),
      },

      {
        field: "product",
        headerName: "Product",
        sortable: true,
        cellRender: (col, data) => cellRender.ProductInfo(data.product),
      },

      // {
      // 	field: "consultants",
      // 	headerName: "Consultants",
      // 	sortable: true,
      // 	cellRender: (col, data) => cellRender.Users(data.consultants, 3, true),
      // },

      // {   field: 'followup', sortable: true,   },
      // {
      // 	field: "status",
      // 	sortable: true,
      // 	cellRender: (col, data) => cellRender.Status(data.status),
      // },
    ],
    searchableFields: [
      "code",
      "status",
      "applicant.name",
      "applicant.cname",
      "applicant.id",
      "cname",
      "email",
      "phone",
      "policyNumber",
    ],
  };
  const formSchema = {};

  useDeepCompareEffect(() => {
    // fetchRenewal();
    const q = createQuery();
    setPreQuery(q);
    tableSchema.preQuery = q;
  }, [consultantId, period]);
  return (
    <>
      {/* <ReactJson src={period} style={{ background: "white" }}></ReactJson> */}
      {/* <ReactJson
        src={preQuery}
        style={{ background: "white" }}
        collapsed
      ></ReactJson> */}
      {/* <DataTable
        data={orders}
        columns={tableSchema.columns}
        hidePagination={true}
        hideSearchBar={true}
      /> */}

      {preQuery && (
        <PageList
          title={"Order Renewal"}
          apiEntity={"order"}
          tableSchema={tableSchema}
          // data={orders}
          // preQueryNotEmpty={true}
          // preQuery={preQuery}
          searchByTextField={false}
          formSchema={formSchema}
          initSort={{ by: "policyCommenceDate", order: "asc" }}
          hideSearchBar={true}
          showAddButton={false}
          tableHeader={{
            component: PeriodFilter,
            props: {
              title: "User Management",
              handlePeriodChange: setPeriod,
              forward: true,
              numPrevPeriods: 3,
              numPeriods: 13,
              by: "M",
              position: "left",
              pb: "xl",
            },
          }}
        />
      )}
    </>
  );
}
